import { motion } from "framer-motion";
import { PenTool, Fingerprint, BookOpen, MonitorSmartphone, Clapperboard, Boxes, Palette, Film, Compass } from "lucide-react";
import { SERVICES } from "../data/projects";
import { SectionHeading } from "./Portfolio";

const ICONS = { PenTool, Fingerprint, BookOpen, MonitorSmartphone, Clapperboard, Boxes, Palette, Film, Compass };

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeading eyebrow="What I Do" title="My Services" />
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group"
            >
              <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#f8f9fa] transition-colors duration-500 group-hover:bg-accent">
                <Icon className="h-6 w-6 text-accent transition-colors duration-500 group-hover:text-white" />
              </div>
              <h3 className="text-xl font-semibold text-[#212529]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6c757d]">{s.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
